// components/LoadingModal.tsx
import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface LoadingModalProps {
  isOpen: boolean;
  message?: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ 
  isOpen, 
  message = 'Subiendo imagen...' 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm mx-4 animate-fadeIn">
        <div className="flex flex-col items-center space-y-4">
          {/* Spinner animado */}
          <LoadingSpinner size={56} thickness={6} />

          {/* Mensaje */}
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {message}
            </h3>
            <p className="text-sm text-gray-500">
              Por favor espera un momento
            </p>
          </div>

          {/* Barra de progreso indeterminada */}
          <div className="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
            <div className="h-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-progress"></div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes progress {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }

        .animate-progress {
          animation: progress 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingModal;